import store from '../../../store/index';
import { Route } from 'vue-router';
import { RoutingRouteEnum } from '../../routes.enum';

export const useCreateApplicationType = (to: Route, from: Route, next: any) => {
  const applicationType = store.getters['application/appType'];

  switch (to.name) {
    case RoutingRouteEnum.CreateApplication_GeneralSettings_Normal:
      if (applicationType === 'normal') {
        next();
      } else next({ name: RoutingRouteEnum.CreateApplication });
      break;
    default:
      next({ name: RoutingRouteEnum.CreateApplication });
      break;
  }
};
